import {breakpoints} from "../breakpoints";

export const media = {
    xs: `@media screen and (min-width: ${breakpoints.values["xs"]}px)`,
    sm: `@media screen and (min-width: ${breakpoints.values["sm"]}px)`,
    md: `@media screen and (min-width: ${breakpoints.values["md"]}px)`,
    lg: `@media screen and (min-width: ${breakpoints.values["lg"]}px)`,
    xl: `@media screen and (min-width: ${breakpoints.values["xl"]}px)`,
}
